/**
 * components/landing/contact/ContactPage.jsx — Phase 9 · Enterprise Sales
 * & Success Center.  Composes the 11 sections in narrative order.
 */

import SiteFrame from '@/components/landing/SiteFrame'
import Hero          from './sections/Hero'
import Enquiry       from './sections/Enquiry'
import Demo          from './sections/Demo'
import Sales         from './sections/Sales'
import Support       from './sections/Support'
import Partnerships  from './sections/Partnerships'
import Consulting    from './sections/Consulting'
import Global        from './sections/Global'
import FAQ           from './sections/FAQ'
import Hours         from './sections/Hours'
import FinalCTA      from './sections/FinalCTA'

const ContactPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />
    <Enquiry />
    <Demo />
    <Sales />
    <Support />
    <Partnerships />
    <Consulting />
    <Global />
    <FAQ />
    <Hours />
    <FinalCTA />
  </SiteFrame>
)

export default ContactPage
